import './Footer.css'; // Make sure to create this file

function Footer() {
	return (
		<footer className="custom-footer">
			<div className="footer-content">
				<div className="footer-left">
					<img src="/brilitech-logo.png" alt="logo" className="footer-logo" />
				</div>
				<div className="footer-right">
					<div className="footer-copyright">
						© 2025 Brilitech. All rights reserved.
					</div>
					<div className="footer-links">
						<a href="/contact" className="footer-link">
							Contact Us
						</a>
						<a href="/privacy" className="footer-link">
							Privacy Policy
						</a>
						<a href="/terms" className="footer-link">
							Terms of Service
						</a>
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
